<template>
  <div
    class="w-full bg-white  overflow-y-auto"
    style="height: calc(100vh - 200px )"
  >
    <ul class="p-0 w-full">
      <li class="h-12 text-gray-800" v-for="(item, i) in items" :key="i">
        <router-link
          :to="item.link"
          class="flex items-center px-4 h-full rounded-lg"
        >
          <div class="mr-2 w-5 h-5 flex items-center">
            <img :src="icon(item.icon, $route.path.includes(item.link))" />
            <p>{{ getRoutingLink }}</p>
          </div>
          <div class="flex items-center">
            <p class="text-sm font-bold truncate">
              {{ $t(`components.settingsManagement.navigation.${item.key}`) }}
            </p>
          </div>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ['item'],
  data: () => ({
    items: [
      {
        key: 'general',
        icon: 'general',
        link: 'general',
      },
      {
        key: 'security',
        icon: 'security',
        link: 'security',
      },
      {
        key: 'trip',
        icon: 'trip',
        link: 'trip',
      },
      {
        key: 'rent',
        icon: 'rent',
        link: 'rent',
      },
      {
        key: 'payments',
        icon: 'payments',
        link: 'payment',
      },
      {
        key: 'iot',
        icon: 'iot',
        link: 'iot',
      },
      {
        key: 'vehicle',
        icon: 'vehicle',
        link: 'vehicle',
      },
      {
        key: 'point',
        icon: 'point',
        link: 'point',
      },
      {
        key: 'events',
        icon: 'events',
        link: 'event',
      },
      {
        key: 'operatorApp',
        icon: 'operator-app',
        link: 'operator',
      },
      {
        key: 'riderApp',
        icon: 'rider-app',
        link: 'rider-app',
      },
      {
        key: 'email',
        icon: 'email',
        link: 'email',
      },
      {
        key: 'businessHour',
        icon: 'business-hour',
        link: 'schedule',
      },
      {
        key: 'quiz',
        icon: 'quiz',
        link: 'quiz',
      },
      {
        key: 'profile',
        icon: 'profile',
        link: 'profile',
      },
    ],
  }),
  computed: {
    getRoutingLink() {
      console.log('test-s', this.$refs['routing-link'])
      return ''
    },
  },

  methods: {
    icon(icon, isActive) {
      if (isActive) {
        return require(`@/assets/icon/settings/menu/${icon}-white.svg`)
      } else {
        return require(`@/assets/icon/settings/menu/${icon}-black.svg`)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.router-link-active {
  background-color: #256baa;
  color: #fff;
}
</style>
